import {EventEmitter} from 'events';
import Touch from './touch';

export default class View {
	constructor(options, params) {
		this.options = options;

		if (this.options.el) {
			this.setEl(this.options.el);
		}

		if (params) {
			this.params = Object.assign({}, params, this.options);
		}
	}

	start() {
		this.initEvents();
	}

	setEl(el) {
		this.el = el;
	}

	initEvents() {
		this.events = new EventEmitter();
	}

	remove() {
		this.el.parentNode.removeChild(this.el);
	}

	touch(type, callback, el) {
		Touch.add(el || this.el, type, callback);
	}
}
